"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MailboxReducer = void 0;
const helpers_1 = require("../helpers");
const mailboxActions_1 = require("./mailboxActions");
const initialState = {
    conversationData: {
        conversations: [],
        hasInitiallyLoaded: false,
        isLoading: false,
    },
    messageData: {
        isLoading: false,
        messages: [],
    },
    unreadConversationsCount: 0,
    unreadMessagesCount: 0,
};
const MailboxReducer = (state = initialState, action) => {
    var _a;
    switch (action.type) {
        case mailboxActions_1.AddConversationAction: {
            return Object.assign(Object.assign({}, state), { conversationData: Object.assign(Object.assign({}, state.conversationData), { conversations: [
                        action.payload.conversation,
                        ...state.conversationData.conversations.filter((c) => c.id !== action.payload.conversation.id),
                    ], isLoading: false }) });
        }
        case mailboxActions_1.AddConversationsAction: {
            const newConversations = action.payload.conversations.map((c) => {
                if (c.id !== state.currentConversationId)
                    return c;
                return Object.assign(Object.assign({}, c), { meta: Object.assign(Object.assign({}, c.meta), { unreadMessageCount: 0 }) });
            });
            return Object.assign(Object.assign({}, state), { conversationData: {
                    conversations: helpers_1.updateConversationListWithNewConversationList(state.conversationData.conversations, newConversations),
                    hasInitiallyLoaded: true,
                    isLoading: false,
                    meta: action.payload.meta,
                } });
        }
        case mailboxActions_1.AddMessageAction: {
            if (!state.ownProfileGid || !state.currentConversationId)
                return state;
            let messageData = state.messageData;
            // Check if message is for the current conversation
            if (state.currentConversationId === action.payload.message.conversation.id) {
                // Message may be in list already, e.g. if it is your own message.
                // In that case just replace the current value.
                if (messageData.messages.find((m) => m.id === action.payload.message.id)) {
                    messageData = Object.assign(Object.assign({}, state.messageData), { messages: helpers_1.enrichMessages(state.messageData.messages.map((m) => m.id === action.payload.message.id ? action.payload.message : m), state.ownProfileGid) });
                }
                else {
                    // Message not in list yet, let's add it
                    messageData = Object.assign(Object.assign({}, state.messageData), { messages: helpers_1.enrichMessages([...state.messageData.messages, action.payload.message], state.ownProfileGid) });
                }
            }
            return Object.assign(Object.assign({}, state), { conversationData: Object.assign(Object.assign({}, state.conversationData), { conversations: helpers_1.updateConversationListWithMessage(state.conversationData.conversations, action.payload.message, state.currentConversationId) }), messageData });
        }
        case mailboxActions_1.AddMessagesAction: {
            if (!state.ownProfileGid)
                return state;
            if (!state.currentConversationId ||
                state.currentConversationId !== action.payload.conversationId) {
                return state;
            }
            const messages = helpers_1.enrichMessages(((_a = action.payload.messagesPayload.meta) === null || _a === void 0 ? void 0 : _a.currentPage) === 1
                ? action.payload.messagesPayload.messages.reverse()
                : [
                    ...action.payload.messagesPayload.messages.reverse(),
                    ...state.messageData.messages,
                ], state.ownProfileGid);
            return Object.assign(Object.assign({}, state), { messageData: Object.assign(Object.assign({}, state.messageData), { isLoading: false, messages, meta: action.payload.messagesPayload.meta }) });
        }
        case mailboxActions_1.RemoveConversationAction: {
            return Object.assign(Object.assign({}, state), { conversationData: Object.assign(Object.assign({}, state.conversationData), { conversations: state.conversationData.conversations.filter((c) => c.id !== action.payload.conversationId), isLoading: false }) });
        }
        case mailboxActions_1.SetConversationIdAction: {
            if (state.currentConversationId === action.payload.conversationId) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { conversationData: Object.assign(Object.assign({}, state.conversationData), { conversations: state.conversationData.conversations.map((c) => {
                        if (c.id !== action.payload.conversationId)
                            return c;
                        return Object.assign(Object.assign({}, c), { meta: Object.assign(Object.assign({}, c.meta), { unreadMessageCount: 0 }) });
                    }) }), currentConversationId: action.payload.conversationId, messageData: {
                    isLoading: false,
                    messages: [],
                } });
        }
        case mailboxActions_1.SetOwnProfileGid: {
            return Object.assign(Object.assign({}, state), { ownProfileGid: action.payload.ownProfileGid });
        }
        case mailboxActions_1.SetUnreadCounts: {
            return Object.assign(Object.assign({}, state), { unreadConversationsCount: action.payload.unreadConversationsCount, unreadMessagesCount: action.payload.unreadMessagesCount });
        }
        default:
            return state;
    }
};
exports.MailboxReducer = MailboxReducer;
